<template>
    <div class="layout-squared">
        <text-headline-primary
            v-if="headline"
            class="headline-primary"
        >
            {{ headline }}
        </text-headline-primary>

        <div class="cells">
            <div class="cell top-left">
                <slot name="top-left" />
            </div>
            <div class="cell top-right">
                <slot name="top-right" />
            </div>
            <div class="cell bottom-left">
                <slot name="bottom-left" />
            </div>
            <div class="cell bottom-right">
                <slot name="bottom-right" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        headline: {
            type: String,
            required: false,
            default: null
        },
        reverse: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style scoped lang="scss">
.headline-primary {
    margin-top: 2rem;
}

@media (min-width: $breakpoint-tablet) {
    .cells {
        display: flex;
        flex-wrap: wrap;
    }

    .cell {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 1.5rem);
    }

    .top-left,
    .bottom-left {
        margin-right: $layout-gap;
    }

    .bottom-left,
    .bottom-right {
        margin-top: $layout-gap;
    }
}
</style>
